module.exports = __webpack_public_path__ + "static/media/integrity-people.8e0931de.jpg";